export const appElement = 'afResetEmail';
